import { ErrorMessage } from "@/models/ErrorMessage";
import { errorStore } from "@/modules/errors/store/errors";
import router from "../../../router/index";
class ErrorManager {
  //errorName for error in field
  //(fieldName, error)
  //missing 0 campo obbligatorio
  //invalid peronalized mezzage or campo invalido
  //TODO traduzioni

  //errorName for dispatch action it return the action name
  //use this to show alert and select in which case is necessary
  error(error) {
    let errorName;
    let message;
    if (error.code=="ERR_CANCELED"){
      console.log("intercept calcel",error.status);
      return new ErrorMessage(
        "CanceledError",
        error.message || error.data ? (error.message?error.message:"") + (error.data?error.data:"") : message,
        error.status
      );
    }
    if (error.status) {
      errorName = error.error;
      if (error.status === 401) {
        console.log("UNAUTHORIZED 401");
        errorName = "Unauthorized";
        message =
          "You don't have the right authorization to access this content";
      }
      if (error.status === 403) {
        console.log("UNAUTHORIZED 403");
        errorName = "Unauthorized";
        message =
          "You don't have the right authorization to access this content";
      }
      if (error.status === 400) {
        console.log("BAD REQUEST 400");
        errorName = "BadRequest";
        message = "Ivalid request";
      }
      if (error.status === 404) {
        console.log("NOT FOUND 404");
        errorName = "NotFound";
        message = "The requested data could not be found";
      }
      if (error.status === 405) {
        console.log("BAD REQUEST 400");
        errorName = "BadRequest";
        message = "The requested data is invalid";
      }
      if (error.status === 409) {
        console.log("CONFLICT 409");
        errorName = "Conflict";
        message = "This content already exist and can't be overwritten";
      }
      if (error.status === 500 || error.status === 502||error.status === 503) {
        console.log("SERVER ERROR", error.status);
        errorName = "ServerError";
        message =
          "Warning! The server has encountered an error " + error.errorId;
      }
      if (error.status === 504 ) {
        console.log("SERVER ERROR", error.status);
        errorName = "TimeoutUpstream";
        message =
          "Warning! The request has timedout " + error.errorId;
      }
    } else {
      errorName = error;
      message = error;
    }
    return new ErrorMessage(
      errorName,
      error.message || error.data ? (error.message?error.message:"") + (error.data?error.data:"") : message,
      error.status
    );
  }
 
  pushError(error) {
    if (error instanceof ErrorMessage) {
      errorStore.updateError(error);
    } else {
      errorStore.updateError(this.error(error));
    }
  }
  pushServerError(error, _root) {
    if (_root) {
      errorStore.setRouteToGoBack(_root);
    }
    router.currentRoute.value.meta["serverErrorSelfManage"]?errorStore.updateError(this.error(error)):errorStore.pageError(this.error(error));
  }
  pushPageError(error) {
    // if(_root){
    //   errorStore.setRouteToGoBack(_root)
    // }
    errorStore.pageError(this.error(error));
  }

  // manage(error, _caseNotFound, _caseUnathorized, _caseConflict) {
  //   const errorType = this.error(error).status;
  //   switch (errorType) {
  //     case "Unauthorized":
  //       return _caseUnathorized
  //         ? () => _caseUnathorized
  //         : this.pushError(error);
  //     case "NotFound":
  //       return _caseNotFound ? () => _caseNotFound : this.pushError(error);
  //     case "caseConflict":
  //       return _caseConflict ? () => _caseConflict : this.pushError(error);
  //     default:
  //       this.pushError(error);
  //   }
  // }
  // manage casess where i want to do something i case of error
  // push error and return reject
  // do something bu only for specific errors
  // - return null or empty for not found
  // - redirect when Unauthorized
  // being able to specify multiple different case
  // being able to define general case and specific case at thesame time

  // args: ErrorMessage, ...{error:"casename",action: ()=>return do}
  manage(error, ...cases) {
    const errorCase = this.error(error).error;
    console.log(error,errorCase);
       try {
      let find = cases.find((c) => c.error == errorCase);   
      console.log('Find case ?',find);
      if (!find) {
        //so i can write default action directly as arg
        find = cases.find((c) => {
          if (c instanceof Function) {
            c = this.defaultCase(c);
          }
          return c.error == "default";
        });
      }
      console.log(find);
      return find ? find.action() : this.deafaultAction(error);
    } catch (e){
      console.log(e);
      return this.deafaultAction(error);
    }
  }
  //define what to do in case of specific error
  case(errorCase, _action) {
    return { error: errorCase, action: _action };
  } // {error:"casename",action: ()=>return do}

  // define not fuond case
  caseNotFound(_action) {
    return { error: "NotFound", action: _action };
  }
  //define default case
  defaultCase(_action) {
    return { error: "default", action: _action };
  }
  //internal default action
  deafaultAction(error) {
    return () => this.pushError(error);
  }
  //iternal default action rejecct
  deafaultReject(error) {
    this.pushError(error);
    return Promise.reject(error);
  }
  clean(){
    errorStore.clean()
  }
  errorPageReject(error) {
    this.pushPageError(error);
    return Promise.reject(error);
  }
}

export default new ErrorManager();
